export const version = '2.21.43';
//# sourceMappingURL=version.js.map